import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionConnectionException12fjxvnnqzby5 as SubscriptionConnectionException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from '../../../../../../../kotlinx-atomicfu/kotlinx/atomicfu/locks/Synchronized.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import {
  plus20p0vtfmu0596 as plus,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ConnectionKeepAliveServerMessage_instance39en4v9fbt32i as ConnectionKeepAliveServerMessage_instance,
  PongServerMessage_instancew68t57iujoli as PongServerMessage_instance,
  PingServerMessage_instance3gqk60x9xj12k as PingServerMessage_instance,
  ParseErrorServerMessage28gxznaow3b26 as ParseErrorServerMessage,
  OperationErrorServerMessage3f3enfqsilvrv as OperationErrorServerMessage,
  CompleteServerMessage1c62v9ocjho2f as CompleteServerMessage,
  ResponseServerMessage1aifb0dqdz3sq as ResponseServerMessage,
  ConnectionErrorServerMessage21355wd69v8tf as ConnectionErrorServerMessage,
  ConnectionAckServerMessage_instance2m47rw1rcdnts as ConnectionAckServerMessage_instance,
} from '../ServerMessage.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  DataClientMessage3splhk6u8gldd as DataClientMessage,
  TextClientMessage15942w7lyj1yt as TextClientMessage,
} from '../ClientMessage.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function restartIdleTimeout($this) {
  var tmp0_safe_receiver = $this.idleTimeoutJob_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.cancel$default_8haxne_k$();
  }
  var tmp = $this;
  tmp.idleTimeoutJob_1 = launch($this.scope_1, VOID, VOID, SubscribableWebSocket$restartIdleTimeout$slambda($this));
}
function shutdownInternal($this, cause) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listeners = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.lock_1;
  if ($this.state_1.equals(SocketState_ShutDown_getInstance())) {
    return Unit_instance;
  }
  $this.state_1 = SocketState_ShutDown_getInstance();
  cancel($this.scope_1);
  $this.shutdownCause_1 = cause;
  listeners.addAll_h3ej1q_k$($this.activeListeners_1.get_values_ksazhn_k$());
  $this.activeListeners_1.clear_j9egeb_k$();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = listeners.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    element.onTransportError_yet6bv_k$(cause);
  }
}
function SubscribableWebSocket$restartIdleTimeout$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(this$0.idleTimeout_1, $completion);
    this$0.shutdown_9u61jz_k$(ApolloNetworkException().new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$('WebSocket is idle'), 1001, 'Idle');
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$onOpen$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    send(this$0.webSocket_1, yield* this$0.wsProtocol_1.connectionInit_8t0fah_k$($completion));
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$onOpen$slambda_0(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(this$0.connectionAcknowledgeTimeout_1, $completion);
    this$0.shutdown_9u61jz_k$(ApolloNetworkException().new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$('Timeout while waiting for connection_ack'), 1001, 'Timeout while waiting for connection_ack');
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$onMessage$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    while (true) {
      yield* delay(this$0.pingInterval_1, $completion);
      var tmp0_safe_receiver = this$0.wsProtocol_1.ping_21r3m_k$();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        send(this$0.webSocket_1, tmp0_safe_receiver);
      }
    }
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$onMessage$slambda_0(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this$0.pending_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      send(this$0.webSocket_1, yield* this$0.wsProtocol_1.operationStart_u0u3fg_k$(element, $completion));
    }
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$startOperation$slambda(this$0, $request) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    send(this$0.webSocket_1, yield* this$0.wsProtocol_1.operationStart_u0u3fg_k$($request, $completion));
    return Unit_instance;
  }), 1);
}
function SubscribableWebSocket$stopOperation$slambda(this$0, $request) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    send(this$0.webSocket_1, this$0.wsProtocol_1.operationStop_jpn5al_k$($request));
    return Unit_instance;
  }), 1);
}
var SubscribableWebSocketClass;
function SubscribableWebSocket() {
  if (SubscribableWebSocketClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, httpHeaders, wsProtocol, pingInterval, connectionAcknowledgeTimeout, idleTimeout) {
        this.wsProtocol_1 = wsProtocol;
        this.pingInterval_1 = pingInterval;
        this.connectionAcknowledgeTimeout_1 = connectionAcknowledgeTimeout;
        this.idleTimeout_1 = idleTimeout;
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.lock_1 = get_atomicfu$reentrantLock();
        this.scope_1 = CoroutineScope(Dispatchers_getInstance().Default_1);
        this.idleTimeoutJob_1 = null;
        this.ackTimeoutJob_1 = null;
        this.state_1 = SocketState_AwaitOpen_getInstance();
        this.shutdownCause_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.activeListeners_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.pending_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var tmp_2;
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(httpHeaders, Collection())) {
            tmp_3 = httpHeaders.isEmpty_y1axqb_k$();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = httpHeaders.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            if (element.name_1.toLowerCase() === 'sec-websocket-protocol') {
              tmp$ret$3 = true;
              break $l$block_0;
            }
          }
          tmp$ret$3 = false;
        }
        if (tmp$ret$3) {
          tmp_2 = httpHeaders;
        } else {
          tmp_2 = plus(httpHeaders, new (HttpHeader())('Sec-WebSocket-Protocol', this.wsProtocol_1.get_name_woqyms_k$()));
        }
        var headers = tmp_2;
        var listener = new (BufferedWebSocketListener())();
        this.webSocket_1 = webSocketEngine.newWebSocket_406efk_k$(serverUrl, headers, listener);
        listener.start_gwju0v_k$(this);
      }
      isShutdown_gfx72d_k$(markActive) {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.lock_1;
        // Inline function 'kotlin.also' call
        var this_0 = this.state_1.equals(SocketState_ShutDown_getInstance());
        if (!this_0 && markActive) {
          var tmp0_safe_receiver = this.idleTimeoutJob_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cancel$default_8haxne_k$();
          }
          this.idleTimeoutJob_1 = null;
        }
        return this_0;
      }
      shutdown_9u61jz_k$(cause, code, reason) {
        shutdownInternal(this, cause);
        this.webSocket_1.close_rqaba_k$(code, reason);
      }
      onOpen_hhqt5_k$() {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.lock_1;
        if (this.state_1.ordinal_1 === 0) {
          launch(this.scope_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda(this));
          var tmp = this;
          tmp.ackTimeoutJob_1 = launch(this.scope_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda_0(this));
          this.state_1 = SocketState_AwaitAck_getInstance();
        }
      }
      onMessage_hav7nm_k$(text) {
        var message = this.wsProtocol_1.parseServerMessage_f93uyf_k$(text);
        if (equals(message, ConnectionAckServerMessage_instance)) {
          var tmp0_safe_receiver = this.ackTimeoutJob_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cancel$default_8haxne_k$();
          }
          this.ackTimeoutJob_1 = null;
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.lock_1;
          if (!this.state_1.equals(SocketState_AwaitAck_getInstance())) {
            return Unit_instance;
          }
          this.state_1 = SocketState_Connected_getInstance();
          var tmp = this.pingInterval_1;
          if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
            launch(this.scope_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda(this));
          }
          launch(this.scope_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda_0(this));
        } else {
          if (message instanceof ConnectionErrorServerMessage()) {
            this.shutdown_9u61jz_k$(SubscriptionConnectionException().new_com_apollographql_apollo_exception_SubscriptionConnectionException_wtl9g7_k$(message.payload_1), 1001, 'Connection error');
          } else {
            if (message instanceof ResponseServerMessage()) {
              // Inline function 'kotlinx.atomicfu.locks.withLock' call
              this.lock_1;
              var tmp1_safe_receiver = this.activeListeners_1.get_wei43m_k$(message.id_1);
              if (tmp1_safe_receiver == null)
                null;
              else {
                tmp1_safe_receiver.onResponse_1e8t5b_k$(message.response_1);
              }
            } else {
              if (message instanceof CompleteServerMessage()) {
                // Inline function 'kotlinx.atomicfu.locks.withLock' call
                this.lock_1;
                var tmp2_safe_receiver = this.activeListeners_1.get_wei43m_k$(message.id_1);
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  tmp2_safe_receiver.onComplete_9lqbvc_k$();
                }
              } else {
                if (message instanceof OperationErrorServerMessage()) {
                  // Inline function 'kotlinx.atomicfu.locks.withLock' call
                  this.lock_1;
                  var tmp3_safe_receiver = this.activeListeners_1.get_wei43m_k$(message.id_1);
                  if (tmp3_safe_receiver == null)
                    null;
                  else {
                    tmp3_safe_receiver.onError_eftw4m_k$(message.payload_1);
                  }
                } else {
                  if (message instanceof ParseErrorServerMessage()) {
                    println("Cannot parse message: '" + message.errorMessage_1 + "'");
                  } else {
                    if (equals(message, PingServerMessage_instance)) {
                      var tmp4_safe_receiver = this.wsProtocol_1.pong_21vjs_k$();
                      if (tmp4_safe_receiver == null)
                        null;
                      else {
                        // Inline function 'kotlin.let' call
                        send(this.webSocket_1, tmp4_safe_receiver);
                      }
                    } else {
                      if (!equals(message, PongServerMessage_instance)) {
                        if (!equals(message, ConnectionKeepAliveServerMessage_instance)) {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      onMessage_2huzew_k$(data) {
        this.onMessage_hav7nm_k$(decodeToString(data));
      }
      onError_546cmu_k$(cause) {
        shutdownInternal(this, cause);
      }
      onClosed_ylsw09_k$(code, reason) {
        shutdownInternal(this, ApolloWebSocketClosedException().new_com_apollographql_apollo_exception_ApolloWebSocketClosedException_flboe8_k$(code == null ? 1001 : code, reason));
      }
      startOperation_3pnjec_k$(request, listener) {
        var cause = null;
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.lock_1;
        var tmp0_safe_receiver = this.idleTimeoutJob_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cancel$default_8haxne_k$();
        }
        this.idleTimeoutJob_1 = null;
        var tmp;
        switch (this.state_1.ordinal_1) {
          case 0:
          case 1:
            this.activeListeners_1.put_4fpzoq_k$(request.requestUuid_1.toString(), listener);
            tmp = this.pending_1.add_utx5q5_k$(request);
            break;
          case 2:
            this.activeListeners_1.put_4fpzoq_k$(request.requestUuid_1.toString(), listener);
            tmp = launch(this.scope_1, VOID, VOID, SubscribableWebSocket$startOperation$slambda(this, request));
            break;
          case 3:
            cause = DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('Apollo: the WebSocket is shut down', this.shutdownCause_1);
            tmp = Unit_instance;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        if (!(cause == null)) {
          listener.onTransportError_yet6bv_k$(ensureNotNull(cause));
        }
      }
      stopOperation_2p8xpj_k$(request) {
        var id = request.requestUuid_1.toString();
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.lock_1;
        if (this.activeListeners_1.containsKey_aw81wo_k$(id)) {
          this.activeListeners_1.remove_gppy8k_k$(id);
          launch(this.scope_1, VOID, VOID, SubscribableWebSocket$stopOperation$slambda(this, request));
          if (this.activeListeners_1.isEmpty_y1axqb_k$()) {
            restartIdleTimeout(this);
          }
        }
      }
    }
    initMetadataForClass($, 'SubscribableWebSocket');
    SubscribableWebSocketClass = $;
  }
  return SubscribableWebSocketClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  SocketState_AwaitOpen_instance = new (SocketState())('AwaitOpen', 0);
  SocketState_AwaitAck_instance = new (SocketState())('AwaitAck', 1);
  SocketState_Connected_instance = new (SocketState())('Connected', 2);
  SocketState_ShutDown_instance = new (SocketState())('ShutDown', 3);
}
var SocketState_AwaitOpen_instance;
var SocketState_AwaitAck_instance;
var SocketState_Connected_instance;
var SocketState_ShutDown_instance;
var SocketStateClass;
function SocketState() {
  if (SocketStateClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'SocketState');
    SocketStateClass = $;
  }
  return SocketStateClass;
}
function dispatch($this, callback) {
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.lock_1;
  // Inline function 'kotlin.also' call
  var this_0 = $this.target_1;
  if (this_0 == null) {
    $this.buffered_1.add_utx5q5_k$(callback);
  }
  var target = this_0;
  if (!(target == null)) {
    callback(target);
  }
}
function BufferedWebSocketListener$onOpen$lambda(it) {
  it.onOpen_hhqt5_k$();
  return Unit_instance;
}
var BufferedWebSocketListenerClass;
function BufferedWebSocketListener() {
  if (BufferedWebSocketListenerClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.lock_1 = get_atomicfu$reentrantLock();
        this.target_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.buffered_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      start_gwju0v_k$(target) {
        while (true) {
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.lock_1;
          if (this.buffered_1.isEmpty_y1axqb_k$()) {
            this.target_1 = target;
            return Unit_instance;
          }
          // Inline function 'kotlin.also' call
          var this_0 = toList(this.buffered_1);
          this.buffered_1.clear_j9egeb_k$();
          var callbacks = this_0;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = callbacks.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            element(target);
          }
        }
      }
      onOpen_hhqt5_k$() {
        return dispatch(this, BufferedWebSocketListener$onOpen$lambda);
      }
      onMessage_hav7nm_k$(text) {
        return dispatch(this, (it) => {
          it.onMessage_hav7nm_k$(text);
          return Unit_instance;
        });
      }
      onMessage_2huzew_k$(data) {
        return dispatch(this, (it) => {
          it.onMessage_2huzew_k$(data);
          return Unit_instance;
        });
      }
      onError_546cmu_k$(cause) {
        return dispatch(this, (it) => {
          it.onError_546cmu_k$(cause);
          return Unit_instance;
        });
      }
      onClosed_ylsw09_k$(code, reason) {
        return dispatch(this, (it) => {
          it.onClosed_ylsw09_k$(code, reason);
          return Unit_instance;
        });
      }
    }
    initMetadataForClass($, 'BufferedWebSocketListener', BufferedWebSocketListener);
    BufferedWebSocketListenerClass = $;
  }
  return BufferedWebSocketListenerClass;
}
function send(_this__u8e3s4, clientMessage) {
  if (clientMessage instanceof TextClientMessage()) {
    _this__u8e3s4.send_oy6aea_k$(clientMessage.text_1);
  } else {
    if (clientMessage instanceof DataClientMessage()) {
      _this__u8e3s4.send_8h7omg_k$(clientMessage.data_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
}
function SocketState_AwaitOpen_getInstance() {
  static_init();
  return SocketState_AwaitOpen_instance;
}
function SocketState_AwaitAck_getInstance() {
  static_init();
  return SocketState_AwaitAck_instance;
}
function SocketState_Connected_getInstance() {
  static_init();
  return SocketState_Connected_instance;
}
function SocketState_ShutDown_getInstance() {
  static_init();
  return SocketState_ShutDown_instance;
}
//region block: exports
export {
  SubscribableWebSocket as SubscribableWebSockethkxzhdarcovi,
};
//endregion

//# sourceMappingURL=SubscribableWebSocket.mjs.map
